export const expanderConstants = {
    home: {
        pinned: "homePinned",
        recent: "homeRecent",
        suggestions: "homeSeggestions",
        locations: "locations",
        shared: "shared",
        approvalCenter: "approvalCenter",
    },
    sharepoint: {
        sites: "sharepointSites",
        folders: "sharepointFolders",
        files: "sharepointFiles"
    },
    sharepointDocument: {
        libraries: "sharepointDocumentLibraries",
        subsites: "sharepointDocumentSubsites"
    },
    oneDrive: {
        folders: "oneDriveFolders",
        files: "oneDriveFiles"
    },
    teams: {
        joinedTeams: "teams",
        channels: "teamChannels"
    },
    tess: {
        activeProjects: "activeProjects",
        draftProjects: "draftProjects",
        finishedProjects: "finishedProjects"
    }
}